<template>
  <b-dropdown
    ref="notificationDropdown"
    class="notification-dropdown mr-5"
    position="is-bottom-left"
    :mobileModal="false"
    aria-role="menu"
    :maxHeight="200"
    :triggers="isMobile ? [''] : ['click']"
    @active-change="
      isOpening => (isOpening ? requestNotificationLists() : null)
    "
  >
    <div slot="trigger" class="cursor-pointer" :alt="General.NOTIFICATIONS">
      <div v-if="getUnreadedNotification" class="notification-alert">
        {{ getUnreadedNotification }}
      </div>
      <b-icon
        icon="bell-outline"
        :type="isContrast ? 'is-black' : 'is-white'"
        size="is-medium"
      />
    </div>

    <div slot="default">
      <NotificationBellContent
        :parentComponentRef="$refs.notificationDropdown"
      />
    </div>
  </b-dropdown>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalWarning from "@/views/App/ModalWarning.vue";
import NotificationBellContent from "@/components/NotificationBellContent.vue";

import { General, App } from "@/utils/constants";

export default {
  name: "NotificationBell",
  components: {
    NotificationBellContent
  },
  data() {
    return {
      General,
      App,
      tabSelected: "all"
    };
  },
  computed: {
    ...mapGetters({
      getRecentNotifications: "getRecentNotifications",
      getUnreadedRecentNotifications: "getUnreadedRecentNotifications",
      user: "getCurrentUser",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),

    getUnreadedNotification() {
      const count = this.getUnreadedRecentNotifications.count;
      return count > 99 ? "+99" : count;
    },

    unreadNotificationList() {
      return (
        this.getUnreadedRecentNotifications.results?.map(notification => {
          const description = notification.description;
          const hasLink = description.includes("LINK");
          return {
            ...notification,
            description: hasLink
              ? description.split("LINK")[0]
              : notification.description,
            descriptionAfterLink: hasLink ? description.split("LINK")[1] : null
          };
        }) || []
      );
    },

    readNotificationList() {
      return (
        this.getRecentNotifications.results?.map(notification => {
          const description = notification.description;
          const hasLink = description.includes("LINK");
          return {
            ...notification,
            description: hasLink
              ? description.split("LINK")[0]
              : notification.description,
            descriptionAfterLink: hasLink ? description.split("LINK")[1] : null
          };
        }) || []
      );
    }
  },
  watch: {
    isMobile(value) {
      if (value && this.$refs.notificationDropdown.isActive)
        this.$refs.notificationDropdown.toggle();
    }
  },
  async beforeMount() {
    await this.userNotificationOnlyCountRequest();
  },
  methods: {
    ...mapActions({
      userNotificationRequest: "userNotificationRequest",
      userNotificationOnlyCountRequest: "userNotificationOnlyCountRequest",
      readNotification: "readNotification",
      deleteNotificationRequest: "deleteNotificationRequest",
      readAllNotifications: "readAllNotifications",
      everyTypeUserNotificationRequest: "everyTypeUserNotificationRequest",
      saveUserNotificationConfig: "saveUserNotificationConfig"
    }),

    async requestNotificationLists() {
      await this.userNotificationRequest({
        currentPage: 1,
        perPage: 20,
        listType: "BELL_AREA_ALL"
      });
      await this.userNotificationRequest({
        currentPage: 1,
        perPage: 20,
        listType: "BELL_AREA_UNREAD"
      });
    },

    async deleteNotification(notificationId) {
      this.$refs.notificationDropdown.toggle();
      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: this.General.WARNING,
          message: `${this.General.TEXTS.CONFIRM_DELETE_NOTIFICATION}`,
          confirm: async () => {
            this.isLoading = true;
            await this.deleteNotificationRequest([notificationId]);
            await this.everyTypeUserNotificationRequest();
            this.isLoading = false;
          }
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    confirmReadAll() {
      this.$refs.notificationDropdown.toggle();
      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: this.General.WARNING,
          message: `${this.General.TEXTS.CONFIRM_MARK_ALL_READ}?`,
          confirm: async () => {
            await this.readAllNotifications();
            await this.everyTypeUserNotificationRequest();
          }
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    toggleNotificationDropdown(notification) {
      this.readNotification([notification.id]);
      this.$refs.notificationDropdown.toggle();
    },

    viewDocument(notification) {
      if (notification.url_pdf) window.open(notification.url_pdf, "_blank");
    },

    async disableNotification(notification) {
      const status = await this.saveUserNotificationConfig([
        {
          notification: notification.sys_notify_type_id,
          type: 3,
          user_id: this.user.id,
          enable: false
        }
      ]);

      if (status) {
        this.snackToast.open({
          message: General.TEXTS.DISABLE_NOTIFICATION.replace(
            "(NOTIFICATION)",
            notification.type
          ),
          type: "is-success",
          duration: 3000
        });
        await this.requestNotificationLists();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.notification-alert {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: -5px;
  top: -5px;
  width: 1.6rem;
  height: 1.6rem;
  font-size: 0.8rem;
  font-weight: 700;
  font-family: Courier, monospace;
  background-color: $warning;
  color: white;
  border-radius: 50%;
}
</style>

<style lang="scss">
@import "@/assets/scss/variables.scss";
.notification-tabs .tabs li.is-active a {
  border-bottom-color: $color-7;
}

.notification-dropdown .dropdown-content {
  padding-bottom: 0;

  .tab-content {
    padding: 1rem 0;
  }
}
</style>
